export default "__VITE_ASSET__Bo9EqU6J__"